import React from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';
import {Helmet} from "react-helmet";

import {Separator, Title, Img} from 'views/AppElements';

import HttpService from 'service/HttpService';
import UserAPI from 'service/api/UserAPI';
import ProductAPI from 'service/api/ProductAPI';

import HeaderContainer from 'containers/HeaderContainer';

import {A} from 'views/AppElements';
import DesignerStore from 'stores/DesignerStore';
import ProductStore from 'stores/ProductStore';

import StoreList from 'views/designer/StoreList';
import ProductList from 'views/product/ProductList';

import AppConstants from 'AppConstants';

import HeaderBanner from 'views/HeaderBanner';
import SearchInput from 'views/SearchInput';

import 'css/home-page.css';
import ArtistSlider from 'views/designer/ArtistSlider';

const BATCH_SIZE = 4;


class ProductsBatchContainer extends React.Component {

	getBatches(number, products) {
		if(!products)
			return <ProductList {...this.props} showSlider={true} />

		const batches = [];
		
		for(var i = 0;i < number;i++) {
			const startIndex = i * BATCH_SIZE;
			const endIndex = i === (number -1)? products.length: startIndex + BATCH_SIZE;

			const productList = <ProductList key={"store_batch_"+i} showSlider={true}  productViewMode="productOnly" autoplay={false} 
								products={products.slice(startIndex, endIndex)} title={i === 0? this.props.title: null} navigator="arrows" />;
			batches.push(productList);
		}

		return batches;
	}

	render() {
		const products = this.props.products;
		
		const numberOfBatches = products? Math.ceil(products.length/BATCH_SIZE): 1;
		const productBatches = this.getBatches(numberOfBatches, products);
		return <div id="populaProducts">
			{productBatches}
		</div>
	}
}


const EachShopThumbnail = (props) => {
	const productType = props.productType; 
	let products = null;

	if(props.products !== null)
		products = props.products[productType.val] || [];

	const thumbnails = products? products.map(p => <Img src={p.productImages[0]} className="shopProductImg" key={p.id} alt={p.title} /> ): null;

	const img = props.img;
	const url = props.url;
	const id = props.id;
	const btnLabel = props.btnLabel;

	return <A href={url}>
			<div id={id} className="shopDiv">
				{
					thumbnails !== null && thumbnails.length === 4 &&
					<div className="flexRow">
						{thumbnails}
					</div>
				}

				{
					thumbnails !== null && thumbnails.length !== 4 &&
					<Img src={img} />
				}
				
				<span className="shopBtn">{btnLabel}</span>
			</div>
		</A>
};

const ShopSection = (props) => {

	return <div>
			<Title title="SHOP" />
			<div id="shopList" className="flexRow">
				<EachShopThumbnail id="shopFrame" url="/shop/frame" 
									img="/images/products/FRAME.jpg" btnLabel="Shop Frame" 
									productType={AppConstants.PRODUCT_TYPES.PHOTO_FRAME}
									products={[]} />

				<EachShopThumbnail id="shopJacket" url="/shop/jacket" 
									img="/images/products/JACKET.jpg" btnLabel="Shop Jacket" 
									productType={AppConstants.PRODUCT_TYPES.JACKET}
									products={[]} />

				<EachShopThumbnail id="shopSweatshirts" url="/shop/sweatshirt" 
									img="/images/products/SWEATSHIRT.jpg" btnLabel="Shop Sweatshirts" 
									productType={AppConstants.PRODUCT_TYPES.SWEAT_SHIRT}
									products={[]} />

				<EachShopThumbnail id="shopHoodies" url="/shop/hoodies" 
									img="/images/products/HOODIES.jpg" btnLabel="Shop Hoodies" 
									productType={AppConstants.PRODUCT_TYPES.HOODIES}
									products={[]} />

				<EachShopThumbnail id="shopTshirt" url="/shop/tshirt" 
									img="/images/products/TSHIRT.jpg" btnLabel="Shop T-Shirt" 
									productType={AppConstants.PRODUCT_TYPES.T_SHIRT}
									products={[]} />
				
				
				
			</div>
		</div>
};

class HomePage extends React.Component {

	static getStores() {
		return [ProductStore, DesignerStore];
	}

	static calculateState(prevState) {
		let newState = {
				popularProducts: ProductStore.getPopularProducts(),

				recentProducts: ProductStore.getRecentProducts(), 
				recentProductsPagination: ProductStore.getRecentProductsPagination(),

				// activeArtists: DesignerStore.getActiveArtists(),
				influencersAndStores: DesignerStore.getAllPopularStores(),

				loading: prevState? prevState.loading: false
			};
		return newState;
	}

	componentDidMount() {
		if(this.state.popularProducts === null)
			ProductAPI.getPopularProducts();

		// if(this.state.activeArtists === null)
		// 	UserAPI.getActiveArtists();

		this.paginateAndfetchRecentProducts();
	}

	paginateAndfetchRecentProducts() {
		if(this.state.loading === false) {
			this.setState({loading: true});
			const pagination = this.state.recentProductsPagination;
			HttpService.getRecentProducts(pagination.nextPageNumber, AppConstants.DEFAULT_PRODUCT_PAGE_SIZE, function(products) {
				this.setState({loading: false});
			}.bind(this));	
		}
		
	}

	render() {
		const popularTags = AppConstants.TOP_TAGS.map(t => <span key={"search_tag_"+t.name} className="tags"><A href={"/search/"+t.name}>{t.value}</A></span>);

		const influencers = this.state.influencersAndStores? this.state.influencersAndStores.filter(u => u.userType === "INFLUENCER").sort(() => .5 - Math.random()): [];
		// const stores = this.state.influencersAndStores? this.state.influencersAndStores.filter(u => u.userType !== "INFLUENCER"): [];
		return (
				<div id="homePage">
					<Helmet>
						<title>Seto Canvas is a marketplace for creative heads like you to sell your art/design printed on different merchandise such as TShirts, Sweatshirts, Wall Frame, Mugs, Pillows and Make Money from Home at your own convenience. | Seto Canvas</title>
    					<meta name="description" content="Seto Canvas is a marketplace for Designers to sell their art printed on merchandise like TShirts, Sweatshirts, Wall Frame, Mugs, Pillows and more." />
					</Helmet>
					
					<HeaderContainer />
					
					<div id="homeSearchBanner">
						<SearchInput keyword={""} title="SEARCH FROM 1,000+ UNIQUE DESIGNS" />

						<div className="searchResTags flexRow">
							{popularTags}
						</div>
					</div>

					<div className="mainContainer" id="influencerList">
						<StoreList stores={influencers} title={"Influencers"} appendViewAll={false} />
					</div>

					<div id="scBanners">
						<HeaderBanner bannerImages={[
												// {"img": "/images/banners/plain-tshirt/plain-tshirt-large-banner.jpg",
												// "mobileImg": "/images/banners/plain-tshirt/plain-tshirt-small-banner.jpg",
												// "title": "Plain T-Shirt available in Nepal at setocanvas.com", "url": "/tag/plain-tshirt"},
												
												{"img": "/images/banners/home-page/custom tee banner.png?v=1.2",
                                        		"title": "Custom T-Shirts for everyone at SetoCanvas.com"},

												{"img": "/images/banners/home-page/Influencer banner.png?v=1.2",
                                        		"title": "Your favorite influencer merchandise at SetoCanvas.com"},

												{"img": "/images/banners/home-page/Photoframe_banner.png?v=1.2",
                                        		"title": "Photo Frames with SetoCanvas.com"},

												{"img": "/images/banners/home-page/Bulk print banner.png?v=1.2",
                                        		"title": "Bulk Custom T-Shirts at SetoCanvas.com"},
												]} autoplay={true} />
					</div>

					 {/* <div className="mainContainer" style={{margin: '0 0 40px 0', minHeight: 'unset', maxWidth: '2000px'}}>
						<ArtistSlider users={this.state.activeArtists} />
					</div> */}

					

					<div className="mainContainer">
						<ProductsBatchContainer products={this.state.popularProducts}
									title="Popular Products" />
						{/* <Separator style={{margin: '10px auto'}} /> */}
					</div>
					
					{/* <div className="mainContainer">
						<ShopSection />
						
						<Separator style={{margin: '10px auto'}} />
					</div> */}


					{/* <div className="mainContainer" id="influencerList">
						<StoreList stores={stores} title={"TOP STORES"} appendViewAll={true} />
					</div> */}

					<div className="mainContainer" id="shopSection">
						<ProductList title={"Shop"} viewProductTags={true} 
									products={this.state.recentProducts} productViewMode="both"
									loadMore={this.paginateAndfetchRecentProducts.bind(this)} 
									hasMore={this.state.recentProductsPagination.hasMore} />
					</div>
				</div>
			);
		
	}
}


export default Radium(Container.create(HomePage));



// WEBPACK FOOTER //
// ./src/pages/HomePage.js